import {
    API_BASE_URL,
    API_PATHS,
} from "../utils/constants/api.constants";

import axiosInstance from "../utils/authUtils";


class PoolService {

    static getAutoPoolStatus(item = {}) {

        const api =
            `${API_BASE_URL}${API_PATHS.getAutoPoolStatus}`;

        return axiosInstance.get(api, {
            params: item,
        });
    }
    static getAllAutoPoolPayment(item = {}) {
        const api =
            `${API_BASE_URL}${API_PATHS.getAllAutoPoolPayment}`;

        const params = {
            page: item?.page || 1,
            limit: item?.limit || 25,
        };

        if (item?.search?.trim()) {
            params.search = item.search.trim();
        }

        if (
            item?.status !== undefined &&
            item?.status !== null &&
            item?.status !== ""
        ) {
            params.status = item.status;
        }

        if (
            item?.paidPool !== undefined &&
            item?.paidPool !== null &&
            item?.paidPool !== ""
        ) {
            params.paidPool = Number(item.paidPool);
        }

        if (item?.download !== undefined) {
            params.download = Number(item.download);
        }

        return axiosInstance.get(api, {
            params,
        });
    }

    static getAutoPoolUsers(item = {}) {

        let api =
            `${API_BASE_URL}${API_PATHS.getAutoPoolUsers}`;

        const params = new URLSearchParams();
        if (
            item?.matrixCycleId !== undefined &&
            item?.matrixCycleId !== null &&
            item?.matrixCycleId !== ""
        ) {
            params.append(
                "matrixCycleId",
                item.matrixCycleId
            );
        }


        if (
            item?.pool !== undefined &&
            item?.pool !== null &&
            item?.pool !== ""
        ) {
            params.append(
                "pool",
                item.pool
            );
        }

        const page =
            Number(item?.page) > 0
                ? Number(item.page)
                : 1;

        params.append(
            "page",
            page
        );


        /* =====================================================
           LIMIT
        ===================================================== */

        const limit =
            Number(item?.limit) > 0
                ? Number(item.limit)
                : 25;

        params.append(
            "limit",
            limit
        );


        /* =====================================================
           BUILD URL
        ===================================================== */

        if (params.toString()) {
            api += `?${params.toString()}`;
        }


        /* =====================================================
           API REQUEST
        ===================================================== */

        return axiosInstance.get(api);
    }


    /* =====================================================
       DISTRIBUTE POOL
    ===================================================== */

    static distributePool(data) {

        const api =
            `${API_BASE_URL}${API_PATHS.distributePool}`;

        return axiosInstance.post(
            api,
            data
        );
    }


    static bulkprepay(data) {

        const api =
            `${API_BASE_URL}${API_PATHS.bulkprepay}`;

        return axiosInstance.post(
            api,
            data
        );
    }


    static prePayAutoPool(data) {

        const api =
            `${API_BASE_URL}${API_PATHS.prePayAutoPool}`;

        return axiosInstance.post(
            api,
            data
        );
    }
    static prepayeligible(item = {}) {
        const api = `${API_BASE_URL}${API_PATHS.prepayeligible}`;

        return axiosInstance.get(api, {
            params: {
                userId: item.userId,
            },
        });
    }




}


export default PoolService;